export const DIR_TYPE_STUDY = 'study';
export const DIR_TYPE_PROJECT = 'project';
export const DIR_TYPE_PROGRAM = 'program';
export const DIR_TYPES = [
  DIR_TYPE_STUDY,
  DIR_TYPE_PROJECT,
  DIR_TYPE_PROGRAM,
];
